module.exports = __webpack_public_path__ + "img/1.0934dd19.png";